import script from "./ServicesVie.vue?vue&type=script&lang=ts&setup=true"
export * from "./ServicesVie.vue?vue&type=script&lang=ts&setup=true"

import "./ServicesVie.vue?vue&type=style&index=0&id=16223aad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16223aad"]])

export default __exports__